import React from "react";
import { dbURL } from "./global";
import { Link } from "react-router-dom";

function Row(props) {
  const { Revision, Resolved, ID } = props.item;
  const { tabItems, userType, idOpt } = props;

  const clicked = idOpt === props.id;
  const adminAccess = userType === "admin" ? true : false;
  const standardAccess = userType === "standard" ? true : false;
  const tabItemHeadings = tabItems.map((item, index) => (
    <div className="mobileHeading">{tabItems[index].textLong}</div>
  ));

  let dateReported = new Date(props.item["DateReportedByManager"]);

  async function toggleDelete() {
    let toggle = !parseInt(props.item["Deleted"]);
    toggle = toggle ? 1 : 0;
    let message = toggle
      ? "Czy na pewno chcesz usunąć wpis?"
      : "Czy chcesz przywrócić wpis?";

    if (window.confirm(message)) {
      await fetch(dbURL + "deleteRow.php", {
        method: "POST",
        body: JSON.stringify([props.item["ID"], toggle]),
        credentials: "include",
      });
      props.modalProps.setUpdate((prev) => prev + 1);
      props.setIdOpt(null);
    }
  }

  async function toggleResolved() {
    let toggle = !parseInt(Resolved);
    toggle = toggle ? 1 : 0;

    await fetch(dbURL + "resolveRow.php", {
      method: "POST",
      body: JSON.stringify([props.item["ID"], toggle]),
      credentials: "include",
    });
    props.modalProps.setUpdate((prev) => prev + 1);
    props.setIdOpt(null);
  }

  async function handleSuggested() {
    props.modalProps.setModalData({
      ...props.item,
      modalType: "suggestSolution",
      tabItems: tabItems,
    });
  }

  function handleOptionsClick() {
    //setClicked((prev) => (adminAccess ? !prev : prev));
    props.setIdOpt(props.id);
    console.log(props.item);
  }

  // TABLE ITEMS
  const tabItemsDisplay = tabItems.map((item, index) => {
    let content = props.item[item.dataItem];

    if (item.short === "doctype")
      content = !parseInt(content) ? "Paragon" : "Faktura";
    if (item.short === "problemorerror")
      content = !parseInt(content) ? "Problem" : "Błąd";
    if (item.short === "datereportedbymanager")
      content = dateReported = dateReported.toLocaleDateString();

    return (
      <div className={item.short} key={index} onClick={handleOptionsClick}>
        {tabItemHeadings[index]}
        <div className="content">{content}</div>
      </div>
    );
  });

  return (
    <div
      className="tableRow"
      data-id={ID}
      data-resolved={Resolved}
      style={
        clicked
          ? {
              border: "1px solid rgb(180,180,180)",
              marginLeft: "-1px",
              boxShadow: "0px 0px 14px rgba(0,0,0,.3)",
              zIndex: "2",
            }
          : {}
      }
    >
      <div className="rowFlags">⬤{parseInt(Revision) ? Revision : ""}</div>
      {tabItemsDisplay}

      <div className={"rowOptions" + (clicked ? " visible" : "")}>
        {standardAccess || adminAccess ? (
          <Link to="modal">
            <div
              className="optionButton optionSuggest"
              onClick={handleSuggested}
            >
              {!parseInt(Resolved) ? "Proponuj rozwiązanie" : "Zgłoś uwagi"}
            </div>
          </Link>
        ) : (
          ""
        )}
        {adminAccess ? (
          <>
            <div
              className="optionButton optionResolve"
              onClick={toggleResolved}
            >
              {!parseInt(Resolved) ? "Zatwierdź" : "Cofnij zatwierdzenie"}
            </div>
            <div className="optionButton optionDelete" onClick={toggleDelete}>
              {props.deletedView ? "Przywróć" : "Usuń"}
            </div>
            <Link to="modal">
              <div
                className="optionButton optionEdit"
                onClick={(e) => {
                  props.modalProps.setModalData({
                    ...props.item,
                    currentUser: props.user,
                    modalType: "edit",
                  });
                }}
              >
                Edytuj
              </div>
            </Link>
            <Link to="modal">
              <div
                className="optionButton optionHistory"
                onClick={(e) => {
                  props.modalProps.setModalData({
                    ...props.item,
                    modalType: "history",
                    tabItems: tabItems
                  });
                }}
                style={{ opacity: parseInt(Revision) ? 1 : 0.4 }}
              >
                Historia ({Revision})
              </div>
            </Link>
          </>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}

export default Row;
